var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.showLoader ? '' : 'hidden',attrs:{"id":"big_loader"}},[_vm._m(0),_c('div',{staticClass:"loader_text"},[_vm._v(_vm._s(_vm.loaderTxt))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"css-loader"},[_c('div'),_c('div'),_c('div'),_c('div')])
}]

export { render, staticRenderFns }